module.exports = __webpack_public_path__ + "static/media/Ubuntu Bold-01.5dc47f10.svg";